
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskInfoPanel.html?raw';
import "../../moreCore/UI/DateTimeInput/DateTimeInput";
import { EvTaskTypes, TodoForm, TodoListTypes } from "../_loadingHelpers/EvTask";
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import "../../moreCore/UI/Container/ExpandableSection";
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import EvServiceBookingView from '../EvService/EvServiceBookingView';
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
class EvTaskInfoPanel extends compose(_StatefulSection) {
    templateString: any = template;

    private datesActualContainer: HTMLElement;
    private datesPlanContainer: HTMLElement;

    private txtAppointmentTitle: HTMLElement;
    private txtEvProjectName: HTMLElement;
    private txtActivityStatus: HTMLElement;
    private txtEvTaskNotes: HTMLElement;
    private notesContainer: HTMLElement;

    private txtTaskType: HTMLElement;
    private txtDatesPlan: HTMLElement;
    private txtDatesActual: HTMLElement;
    private txtTaskStatus: HTMLElement;

    private expanderEvPlanning: MdsLax<InstanceType<typeof ExpandableSection>>;
    private expanderEvTask: MdsLax<InstanceType<typeof ExpandableSection>>;
    //private expanderTodos: ExpandableSection;
    
    private enableTodos: boolean = false;
    private todosContainer: HTMLElement;
    private sectionTodos: HTMLElement;

    private enableEvServiceBookings: boolean = false;
    private sectionServiceBookings: HTMLElement;
    private serviceBookingsContainer: HTMLElement;
    private genericEntityView: HTMLElement;
    private genericView: MdsLax<InstanceType<typeof GenericEntityView>>;
   // private expanderEvServiceBookings: ExpandableSection;

    loadById(ID: string) {
        this.setStartupState("loading");
        this.StandbyStart();

        this.RequestManager.post(
            window.appRoot + "EvTask/LoadDetails",
            {
                "jsonData": JSON.stringify({ "evTaskID": ID})
            },
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError)
        );
    }

    private _onLoadDataResponse(data: EvTaskTypes.InfoPanelData) {
        this.StandbyStop();
        this.setData(data);

        this.emit("loaded", data);
    }

    private _onLoadDataError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    afterSetData() {
        
        let data = this.sourceData as EvTaskTypes.InfoPanelData;

        if (data.statusColor) {
            this.UiModder.domStyle.set(this.txtTaskStatus, "color", data.statusColor.TextColor?.Hex);
            this.UiModder.domStyle.set(this.txtTaskStatus, "backgroundColor", data.statusColor.BackColor?.Hex);
        }

        this.UiModder.domClass.toggle(this.txtDatesActual, "bold", data.datesPlan != data.datesActual);

        if (data.evActivityStatusColor) {
            this.UiModder.domStyle.set(this.txtActivityStatus, "color", data.evActivityStatusColor.TextColor?.Hex);
            this.UiModder.domStyle.set(this.txtActivityStatus, "backgroundColor", data.evActivityStatusColor.BackColor?.Hex);
        }        

        this.hideNode(this.notesContainer, data.note == null || data.note == "");

        this.UiModder.domConstruct.empty(this.genericEntityView);
        this.genericView = new GenericEntityView();
        this.genericView.setup(data.ID, data.Classname, null, null, this.genericEntityView);

        if (this.hasFeature("EvTask/ToDos")) {

            if (data.todoIDs && this.enableTodos) {
                //this.hideNode(this.expanderTodos.domNode, !this.enableTodos);
                this.hideNode(this.sectionTodos, false);

                if (data.todoIDs.length <= 0) {
                    this.UiModder.domAttr.set(this.todosContainer, "innerHTML", this.translations["General__NoEntries"]);
                    //this.expanderTodos.setMarking(ExpandableSectionMarkings.empty);
                } else {

                    this.UiModder.domConstruct.empty(this.todosContainer);
                    //this.expanderTodos.setMarking(ExpandableSectionMarkings.hasContent);

                    for (let todoID of data.todoIDs) {
                        //let container = this.UiModder.domConstruct.create("div", {
                        //    className: "padding round border hoverDark",
                        //    innerHTML: todo.c_todo_description
                        //}, this.todosContainer);

                        let container = new ExpandableSection();
                        container.setup("",
                            "ToDo",
                            "small",
                            true, true, false);

                        container.placeAt(this.todosContainer);

                        let todoForm = new TodoForm();

                        container.setContent(todoForm);

                        todoForm.on("dataSet", lang.hitch(this, this._onLoadTodo, container))
                        todoForm.loadData(todoID);
                    }
                }
            }
        }

        if (this.hasFeature("EvTask/EvService")) {
            if (data.evServiceBookings && this.enableEvServiceBookings) {
                this.hideNode(this.sectionServiceBookings, false);

                this.UiModder.domConstruct.empty(this.serviceBookingsContainer);

                if (data.evServiceBookings.length <= 0) {
                    this.UiModder.domAttr.set(this.serviceBookingsContainer, "innerHTML", this.translations["General__NoEntries"]);
                    //this.expanderTodos.setMarking(ExpandableSectionMarkings.empty);
                } else {

                    for (let svb of data.evServiceBookings) {
                        let container = new ExpandableSection();

                        container.setup("",
                            svb.service_type == 1 ? svb.quantity_multiplier + " " + svb.description : svb.description,
                            "small",
                            true, true, false);

                        container.placeAt(this.serviceBookingsContainer);

                        let svbView = new EvServiceBookingView();

                        container.setContent(svbView.domNode);

                        svbView.setData(svb);


                    }
                }
            }
        }
    }

    private _onLoadTodo(expander: MdsLax<InstanceType<typeof ExpandableSection>>, data: TodoListTypes.TodoAppointmentEntity) {
        expander.setMarking(data.is_finished ? ExpandableSectionMarkings.checked : ExpandableSectionMarkings.hasContent);
        expander.setHeading(data.c_todo_description);
    }

    _setExpandersAttr(state: string) {
        this.expanderEvPlanning.toggleExpand(state !== "collapsed");
        this.expanderEvTask.toggleExpand(state !== "collapsed");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.enableTodos = this.hasUserRole("EvTask_TodoList");
        this.enableEvServiceBookings = this.hasUserRole("EvTask_EvServiceBookings");
 
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskInfoPanel);